import * as z from "zod/v4";

export const getFavoritesEmail = {
  name: "getFavoritesEmail" as const,
  input: z.object({}),
  output: z.string(),
};
